// extracted by mini-css-extract-plugin
export default {"skipNavButton":"v8qSX"};